export default __webpack_public_path__ + "static/media/startScreen2.ed80b39f.jpg";